export enum Timezone {
  'Australia/Sydney' = 'Australia/Sydney',
}
